import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import {
    CheckCircleRounded,
    DescriptionRounded,
    Info,
    Insights,
    PlayArrowRounded,
    Schedule,
    Visibility,
} from '@mui/icons-material'
import {
    Box,
    Chip,
    Collapse,
    IconButton,
    LinearProgress,
    Tooltip,
    useTheme,
} from '@mui/material'
import { SectionState } from '../../../../../features/types'

interface Props {
    section?: any
    isLast?: boolean
    selectedSection?: SectionState
    handleSelect?: () => void
}

const Section: React.FC<Props> = ({
    section = { title: 'Video 1' },
    isLast,
    handleSelect,
    selectedSection,
}) => {
    const { formatMessage } = useIntl()
    const theme = useTheme()
    const [expanded, setExpanded] = useState(false)

    const styles = {
        wrapper: {
            p: 1,
            borderBottom: isLast ? '' : `1px solid ${theme.palette.grey[200]}`,
        },
        flexCenter: {
            display: 'flex',
            alignItems: 'center',
        },

        typeIcon: {
            width: '40px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mr: 1,
        },
        title: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
    }

    const TypeIcon = () =>
        section.type === 'video' ? <PlayArrowRounded /> : <DescriptionRounded />

    return (
        <Box
            sx={styles.wrapper}
            onClick={() => handleSelect()}
        >
            <Box sx={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                <Box sx={styles.typeIcon}>
                    <TypeIcon />
                </Box>

                <Box sx={{ width: '100%' }}>
                    <Box sx={styles.title}>
                        <Box>{section.title}</Box>

                        <Box sx={styles.flexCenter}>
                            {section.progress === 100 && (
                                <CheckCircleRounded
                                    color="secondary"
                                    sx={{ mr: 1 }}
                                />
                            )}
                            {section.progress}%
                        </Box>
                    </Box>

                    <LinearProgress
                        variant="determinate"
                        value={section.progress}
                        color={'primary'}
                        sx={{ mt: 1 }}
                    />
                </Box>

                <Tooltip
                    title={formatMessage({ id: 'seeResult' })}
                    placement="top"
                    arrow
                >
                    <IconButton
                        sx={{
                            ml: 2,
                            visibility:
                                section.type === 'video' ? 'hidden' : 'visible',
                        }}
                    >
                        <Insights />
                    </IconButton>
                </Tooltip>

                <Chip
                    sx={{ ml: 1, mr: 1, p: '0px 4px', cursor: 'pointer' }}
                    label="10"
                    onClick={() => setExpanded(!expanded)}
                    avatar={<Visibility />}
                />
            </Box>

            <Collapse in={expanded}>
                <Box
                    sx={{
                        background: theme.palette.grey[100],
                        display: 'flex',
                        borderRadius: '8px',
                        mt: 2,
                        p: 2,
                        maxHeight: '160px',
                        overflow: 'auto',
                    }}
                >
                    <Box sx={{ mr: 8 }}>
                        <Box
                            sx={{
                                mb: 1,
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <Box mr={1}>Дата посещения</Box>

                            <Info
                                fontSize="small"
                                color="disabled"
                            />
                        </Box>

                        <Box mb={1}>29 | 10 | 2022</Box>
                        <Box mb={1}>29 | 10 | 2022</Box>
                        <Box mb={1}>29 | 10 | 2022</Box>
                        <Box mb={1}>29 | 10 | 2022</Box>
                        <Box mb={1}>29 | 10 | 2022</Box>

                        <Box mb={1}>29 | 10 | 2022</Box>
                        <Box mb={1}>29 | 10 | 2022</Box>
                        <Box mb={1}>29 | 10 | 2022</Box>
                        <Box mb={1}>29 | 10 | 2022</Box>
                        <Box mb={1}>29 | 10 | 2022</Box>
                    </Box>

                    <Box>
                        <Box
                            sx={{
                                mb: 1,
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <Box mr={1}>Время посещения</Box>

                            <Schedule
                                fontSize="small"
                                color="disabled"
                            />
                        </Box>

                        <Box mb={1}>15 : 53</Box>
                        <Box mb={1}>15 : 53</Box>
                        <Box mb={1}>15 : 53</Box>
                        <Box mb={1}>15 : 53</Box>
                        <Box mb={1}>15 : 53</Box>

                        <Box mb={1}>15 : 53</Box>
                        <Box mb={1}>15 : 53</Box>
                        <Box mb={1}>15 : 53</Box>
                        <Box mb={1}>15 : 53</Box>
                        <Box mb={1}>15 : 53</Box>
                    </Box>
                </Box>
            </Collapse>
        </Box>
    )
}

export default Section
